import React from 'react'
import { Row, Col, Typography } from 'antd'
import { ReactComponent as Illus } from '../assets/illus.svg'
import HomepageFeatures from './home/HomepageFeatures'

const { Title, Text } = Typography

const Home: React.FC = () => {
    return (
        <div>
            <div className="container">
                <div className="mb-small">
                    <Title level={2} id="description">
                        Wallex Simulator
                    </Title>
                    <Row style={{ width: '100%' }} align="top">
                        {/* AntD using 24-span column system instead of the usual 12 */}
                        <Col md={{ span: 15 }} xs={{ span: 24 }}>
                            <Text style={{ fontSize: '1rem' }}>
                                Wallex Simulator is a web-based app API that enables seamless integration with Wallex, designed to mirror real world scenarios. You can use
                                this simulator to simulate Collection, User, Simple Payment, Funding, and Deduction. This powerful tool provides a way to simulate financial
                                transactions and user data, making it a versatile solution for our partner to integrate with Wallex’s suite of services.
                            </Text>
                        </Col>
                        <Col span="9" className="col col--3 text--center margin-top--md">
                            <Illus className="illustration" />
                        </Col>
                    </Row>
                </div>

                <main>
                    <HomepageFeatures />
                </main>
            </div>
        </div>
    )
}
export default Home
